import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import { TextAreaFormField } from '@playbookux/playbook-web-core';

import {
  Container,
  ContainerTitle,
  IconTitle,
  Title,
  QuestionIndex,
} from './styles';

import ErrorMessage from '../error';

function FirstClickTest(props) {
  const {
    index,
    taskIndex,
    testType,
    errors,
    touched,
  } = props;

  let label = '';

  if (testType === 'survey') {
    label = `${(taskIndex || taskIndex === 0) ? `surveysPages[${taskIndex}]` : ''}tasks.${index}.label`;
  } else {
    label = `${(taskIndex || taskIndex === 0) ? `tasks[${taskIndex}]` : ''}tasks.${index}.label`;
  }
  return (
    <Container>
      <ContainerTitle>
        <QuestionIndex>{index + 1}</QuestionIndex>
        <IconTitle src="/images/question-first-click-test.png" />
        <Title color="questionTitlePreference">
          First Click
        </Title>

      </ContainerTitle>
      <Field
        placeholder="Where would you click to..."
        minWidth="100%"
        component={TextAreaFormField}
        name={label}
      />
      <ErrorMessage
        index={index}
        errors={errors}
        touched={touched}
      />
    </Container>
  );
}

export default React.memo(FirstClickTest);

FirstClickTest.propTypes = {
  index: PropTypes.number.isRequired,
  taskIndex: PropTypes.number.isRequired,
  testType: PropTypes.string.isRequired,
  errors: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]).isRequired,
  touched: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape()),
    PropTypes.shape(),
  ]).isRequired,
};
